import * as NotificationsActions from '../../../main/actions/notifications-actions';
import { authenticatedPatientSelector } from '../../../main/selectors/patients-selectors.ts';

module.exports = {
  controller: class ProfileController {

    static $inject = [
      '$anchorScroll',
      '$ngRedux',
      '$location',
      '$scope',
      '$state',
      '$timeout',
      'LinkedPatients',
      'ProductService',
      'PatientsService',
      'ProfileService',
    ];

    linkedPatients = [];
    unlinkingPatientIds = [];

    // Last patient recently linked
    lastLinkedPatient = null;

    constructor(
      $anchorScroll,
      $ngRedux,
      $location,
      $scope,
      $state,
      $timeout,
      LinkedPatients,
      ProductService,
      PatientsService,
      ProfileService,
    ) {
      this.$anchorScroll = $anchorScroll;
      this.$location = $location;
      this.$ngRedux = $ngRedux;
      this.$scope = $scope;
      this.$state = $state;
      this.$timeout = $timeout;
      this.LinkedPatients = LinkedPatients;
      this.PatientsService = PatientsService;
      this.ProductService = ProductService;
      this.ProfileService = ProfileService;
    }

    $onInit() {
      this.$scope.$on('$destroy', this.$ngRedux.connect(state => ({
        authenticatedPatient: authenticatedPatientSelector(state),
        group: state.group,
      }))(this));

      this.getLinkedPatients();
    }

    hasManitobaProduct() {
      return this.ProductService.isAvailable('MANITOBA_BOOKING');
    }

    hasGenericHinProduct() {
      return this.ProductService.isAvailable('GENERIC_PHN');
    }

    getLinkedPatients() {
      this.LinkedPatients.query({ patientId: this.authenticatedPatient.id, group_id: this.group.id }, (linkedPatients) => {
        this.linkedPatients = linkedPatients;
      });
    }

    onPatientLinked(patient) {
      this.$location.hash('linkedPatients');
      this.$anchorScroll();

      async.series([
        (callback) => {
          // Reload authenticated patient
          this.PatientsService.loadPatient(this.authenticatedPatient.id).then(() => {
            callback(null);
          });
        },
        (callback) => {
          // Reload notifications for all patients
          this.ProfileService.getNotification(this.authenticatedPatient, this.group.id, (response) => {
            this.$ngRedux.dispatch(NotificationsActions.setNotifications(response.data));
            callback(null);
          });
        },
      ], () => {
        this.linkedPatients.push(patient);
        this.lastLinkedPatient = patient;

        this.$timeout(() => {
          this.lastLinkedPatient = null;
        }, 5000);
      });
    }

    setUnlinkPatient(id) {
      if (!this.unlinkingPatient(id)) {
        this.unlinkingPatientIds.push(id);
      }
    }

    cancelUnlinkPatient(linkedId) {
      this.unlinkingPatientIds = this.unlinkingPatientIds.filter(patientId => patientId !== linkedId);
    }

    unlinkingPatient(linkedId) {
      return !!this.unlinkingPatientIds.find(patientId => patientId === linkedId);
    }

    unlinkPatient(linkedId) {
      this.PatientsService.unlinkPatient(this.authenticatedPatient.id, {
        group_id: this.group.id,
        linked_id: linkedId,
      }, () => {
        this.cancelUnlinkPatient(linkedId);
        this.getLinkedPatients();
      });
    }

    get hinMessageSuffix() {
      if (this.hasManitobaProduct()) {
        return 'phin';
      } else if (this.hasGenericHinProduct()) {
        return 'generic_hin';
      }
      return 'hin';
    }
  },
  template: `
    <h2 class="title -main">{{ 'update.profile.title' | translate }}</h2>
    <p>{{ 'update.profile.information' | translate }}</p>

    <h2 class="title -secondary">{{ 'update.profile.linkedPatients.title' | translate }}</h2>
    <p>{{ 'update.profile.linkedPatients.information' | translate }}</p>

    <h3 class="title -sub">{{ 'update.profile.linkedPatients.subtitle' | translate }}</h3>

    <div id="linkedPatients" class="linked-patient">
      <div class="linked-patient-row linked-patient-header">
        <div>
          <span class="linked-patient-cell">{{ 'update.profile.linkedPatients.table.name' | translate }}</span>
          <span class="linked-patient-cell">{{ 'update.profile.linkedPatients.table.' + $ctrl.hinMessageSuffix | translate }}</span>
          <span class="linked-patient-cell">{{ 'global.actions' | translate }}</span>
        </div>
      </div>
      <div class="linked-patient-body">
        <div class="linked-patient-row" ng-repeat="linkedPatient in $ctrl.linkedPatients" ng-class="{ '-newest': linkedPatient.id == $ctrl.lastLinkedPatient.id }">
          <div>
            <div class="linked-patient-cell name">
              <span class="flash" ng-show="linkedPatient.id == $ctrl.lastLinkedPatient.id">
                {{ 'update.profile.linkedPatients.table.added' | translate }}
                <i class="icon -ok_12x10"></i>
              </span>
              {{ linkedPatient | patientName }}
            </div>
            <div class="linked-patient-cell hin">{{ linkedPatient.hin }}</div>
            <div class="linked-patient-cell action">
              <button ng-click="$ctrl.setUnlinkPatient(linkedPatient.id)">
                <span>{{ 'update.profile.linkedPatients.unlink_patient_action' | translate }}</span>
              </button>
            </div>
          </div>
          <div class="linked-patient-unlinking" ng-class="{ '-visible': $ctrl.unlinkingPatient(linkedPatient.id) }">
            <span class="linked-patient-unlinking-text">
              {{ 'update.profile.linkedPatients.unlink_patient_text' | translate }}
            </span>
            <div class="linked-patient-unlinking-actions">
              <button class="hollow-button" ng-click="$ctrl.cancelUnlinkPatient(linkedPatient.id)">
                {{ 'global.no' | translate }}
              </button>
              <button class="button" ng-click="$ctrl.unlinkPatient(linkedPatient.id)">
                {{ 'global.yes' | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="linked-patient-row" ng-if="!$ctrl.linkedPatients.length">
          <div class="linked-patient-cell" class="empty-message">{{ 'update.profile.linkedPatients.table.blank' | translate }}</div>
        </div>
        </div>
      </div>
    </div>

    <h3 class="title -sub">{{ 'update.profile.linkedPatients.title' | translate }}</h3>
    <p>{{ 'update.profile.linkedPatients.helpText' | translate }}</p>

    <link-patient-form group="$ctrl.group" parent-patient="$ctrl.authenticatedPatient" patient-linked="$ctrl.onPatientLinked(patient)"></link-patient-form>
  `,
};



// WEBPACK FOOTER //
// ./profile/components/tabs/profile.js